import { LiliButton } from '@lili/lili-frontend-common';
import Heading from '../../../../../generic-components/Heading';
import { UserMessage } from '../../../../../DesignSystem/LiliUserMessage/UserMessage';
import { ReactComponent as AlertIcon } from '../../../../../assets/icons/svg/stamp-icons/ic-stamp-alert.svg';
import i18next from '../../../../../i18n/i18n';

interface IProps {
  onClosePopUp: () => void;
  amount?: number;
  message: string;
}

export const PaymentErrorDisclaimer = ({ onClosePopUp, amount, message }: IProps) => (
  <UserMessage onClick={onClosePopUp} id='paymentCannotProcessed'>
    <div className='fadeIn flex flex-col items-center text-center rounded-[8px] bg-bw00 px-[24px] pt-[34px] pb-[24px] w-[380px]'>
      <AlertIcon className='mb-[20px]' />
      <Heading
        title='This payment cannot be processed at the moment'
        className='font-metricR text-[20px] text-bw08 mb-[12px]'
      />
      {amount && !message && (
        <Heading
          title={`A payment of $${amount} exceeds the maximum allowable amount for all available payment methods. Please try a lower amount`}
          className='font-metricR text-[16px] text-bw07 mb-[28px]'
        />
      )}
      {!amount && message && <Heading title={message} className='font-metricR text-[16px] text-bw07 mb-[28px]' />}
      <LiliButton
        onClick={onClosePopUp}
        title={i18next.t('GOT_IT')}
        className='w-full'
        id='paymentCannotProcessedCta'
      />
    </div>
  </UserMessage>
);
